import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectNotificationsRemoveButton: {
		defaultMessage: 'Remove',
		id: 'personal-settings-notifications-config-table.project-notifications-config.project-notifications-config-table.project-notifications-remove-button.project-notifications-remove-button',
		description: 'The button label for removing project notification customisations',
	},
	projectNotificationsRemoveUndoFlagTitle: {
		defaultMessage:
			"Custom notifications removed.\nYou'll still receive default notifications for {projectName}.",
		id: 'personal-settings-notifications-config-table.project-notifications-config.project-notifications-config-table.project-notifications-remove-button.project-notifications-remove-undo-flag-title',
		description:
			'The title for the undo flag shown after removing project notification customised settings',
	},
	projectNotificationsRemoveUndoFlagActionNonFinal: {
		defaultMessage: 'Undo',
		id: 'personal-settings-notifications-config-table.project-notifications-config.project-notifications-config-table.project-notifications-remove-button.project-notifications-remove-undo-flag-action-non-final',
		description: 'The button label for undoing the removal of project notification customisations',
	},
});
